import { isAndroid, dateDiffInDays, dateFormatter, decodeEntities, generateImagePath, setStylesOnElement } from "./Misc";
import BubbleType from "../model/BubbleType";
import { isBubbleTypeRichMediaWidget } from "../controller/TranscriptController";
import { Constants } from "../model/Constants";

export default class PrintMgr {
    $app: any;

    constructor(app) {
        this.$app = app;
    }

    static displayPrintWindow(app) {
        const printConfig = app.getUIConfig().printWindowConfig || {};
        const appConfigProps = app.getUIConfig().appConfigProps || {};
        const dateFormat = appConfigProps.dateFormat || Constants.DEFAULT_DATE_FORMAT;
        const timeStampFormat = appConfigProps.timeStampFormat || Constants.DEFAULT_TIMESTAMP_FORMAT;
        const pLeft = printConfig.leftPosition || 0;
        const pTop = printConfig.topPosition || 0;
        const pWidth = printConfig.width || 600;
        const pHeight = printConfig.height || 400;
        const printWindow = window.open("", "inqPrint", `left=${pLeft},top=${pTop},height=${pHeight},width=${pWidth},status=0,toolbar=0`);
        const pNode: any = document.body.parentNode;
        const links = pNode.getElementsByTagName("LINK");
        const engagementId = app.getEngagementID();
        const isAsync = app.isAsyncChat;
        const conversationId = app.getLatestConversationID();
        let previousDateTimestamp = new Date().getTime();
        let isDifferenceInDates = false;

        if (printWindow) {
            printWindow.onload = function () {
                return true;
            };

            printWindow.document.open();
            printWindow.document.write("<!DOCTYPE html><html><head>");

            for (let i = 0; i < links.length; i++) {
                const linkHref = links[i].href;

                if (linkHref && linkHref.includes(".css")) {
                    printWindow.document.write(`<link type="text/css" rel="stylesheet" media="print" href="${linkHref}" />`);
                    printWindow.document.write(`<link type="text/css" rel="stylesheet" media="screen" href="${linkHref}" />`);
                }
            }

            printWindow.document.write("</head>");

            const fragment = document.createElement("div");

            const header = PrintMgr.createPrintViewElement("header", "print-view-header");

            const logoImgUrl = printConfig.logoConfig && generateImagePath(printConfig.logoConfig, app);

            const title = PrintMgr.createPrintViewElement("div", "print-title",
                printConfig.transcriptTitleStyles);
            title.innerText = (printConfig && printConfig.transcriptTitle) || "Chat Transcript";
            header.appendChild(title);

            if (logoImgUrl) {
                const logo = PrintMgr.createPrintViewElement("img", "print-logo", printConfig.transcriptLogoStyles);
                logo.src = logoImgUrl;
                header.appendChild(logo);
            }

            fragment.appendChild(header);

            const newLineElement = PrintMgr.createPrintViewElement("br", "");

            if (printConfig.transcriptId) {
                const transcriptIdContainer = PrintMgr.createTranscriptIDElement(printConfig,
                    isAsync, conversationId, engagementId);
                fragment.appendChild(transcriptIdContainer);
            }

            if (printConfig.transcriptHeader) {
                const transcriptHeader = PrintMgr.createTranscriptHeaderElement(printConfig);
                fragment.appendChild(transcriptHeader);
            }

            const messages = app.renderEngine.getMessages();
            const dateTimeStyles = printConfig.transcriptDateTimeStyles || {};

            if (printConfig.transcriptDateTime) {
                const timeStamp = messages.length > 0 ? parseInt(messages[0].getTimeStamp(), 10)
                    : new Date().getTime();
                PrintMgr.createTranscriptDateElement(timeStamp, dateFormat,
                    fragment, dateTimeStyles.date);
            }

            messages.forEach(msg => {
                let cont;
                let alias;
                let text;
                let timeStampElement;

                if (msg.getMessageBubble() === BubbleType.AGENT_MESSAGE
                    || msg.getMessageBubble() === BubbleType.VIRTUAL_AGENT_MESSAGE
                    || msg.getMessageBubble() == BubbleType.OPENER_MESSAGE
                    || PrintMgr.isMsgTextDisplayedinRichView(msg)
                ) {
                    cont = PrintMgr.createPrintViewElement("div", "print-agent-message");
                    alias = PrintMgr.createPrintViewElement("div", "print-agent-alias", printConfig.transcriptAgentAliasStyles);
                    alias.innerHTML = `${msg.getName() || "Agent"}<span>: </span>`;
                    text = PrintMgr.createPrintViewElement("div", "print-agent-text", printConfig.transcriptTextStyles);
                    text.innerHTML = decodeEntities(msg.getMessageText());
                    timeStampElement = PrintMgr.createPrintViewElement("div",
                        "agent-time-stamp", dateTimeStyles.agentTimeStamp);
                } else if (msg.getMessageBubble() === BubbleType.CUSTOMER_MESSAGE && msg.getMessageText() != Constants.EA) {
                    cont = PrintMgr.createPrintViewElement("div", "print-customer-message");
                    alias = PrintMgr.createPrintViewElement("div", "print-customer-alias", printConfig.transcriptCustomerNameStyles);
                    alias.innerHTML = `${msg.getName()}<span>:</span>`;
                    text = PrintMgr.createPrintViewElement("div", "print-customer-text", printConfig.transcriptTextStyles);
                    text.innerHTML = msg.getMessageText();
                    timeStampElement = PrintMgr.createPrintViewElement("div",
                        "customer-time-stamp", dateTimeStyles.customerTimeStamp);
                }

                const timeStamp = parseInt(msg.getTimeStamp(), 10);
                const previousMsgDate = new Date(previousDateTimestamp);
                const currentMsgDate = new Date(timeStamp);
                const differenceInDates = dateDiffInDays(previousMsgDate, currentMsgDate);
                isDifferenceInDates = differenceInDates >= 1;

                if (isDifferenceInDates && printConfig.transcriptDateTime) {
                    PrintMgr.createTranscriptDateElement(timeStamp, dateFormat,
                        fragment, dateTimeStyles.date);
                }

                if (cont) {
                    cont.appendChild(alias);
                    cont.appendChild(newLineElement);
                    cont.appendChild(text);
                    cont.appendChild(newLineElement);

                    if (printConfig.transcriptDateTime) {
                        timeStampElement.innerHTML = dateFormatter(timeStamp, timeStampFormat);
                        cont.appendChild(timeStampElement);
                    }

                    fragment.appendChild(cont);
                }

                previousDateTimestamp = timeStamp;
            });

            if (printConfig.transcriptFooter) {
                const footer = PrintMgr.createPrintViewElement("div", "print-view-footer",
                    printConfig.transcriptFooterStyle);
                footer.innerHTML = printConfig.transcriptFooter;
                fragment.appendChild(footer);
            }

            printWindow.document.write(`<body class='print'>`)
            if (app.bridge.isTablet() || isAndroid()) {
                printWindow.document.write("<br/><button onclick='window.close()' style='display: block;margin: 0 auto;padding: 5px'>Close</button></br>");
            }

            printWindow.document.write(fragment.innerHTML);
            printWindow.document.write(
                `<script>
                    window.onload = printTranscript;
                    function printTranscript() {
                        setTimeout(function () {
                            window.print();
                        }, 2000);

                        const isAndroidDevice =
                            navigator.userAgent.toLowerCase().indexOf("android") > -1;
                        if (isAndroidDevice) return;

                        window.addEventListener("afterprint", function () {
                            window.close();
                        });
                    }
                </script>`
            );

            printWindow.document.write("</body></html>");
            printWindow.document.close();
        }
    }

    static createPrintViewElement(tagName, className, styleProp?) {
        const el = document.createElement(tagName);

        if (className) {
            el.classList.add(className);
        }

        if (styleProp) {
            setStylesOnElement(styleProp, el);
        }
        return el;
    }

    static isMsgTextDisplayedinRichView(msg) {
        const isRichMediaWidget = isBubbleTypeRichMediaWidget(msg.getMessageBubble());
        const hasShowMessageText = msg.getRichData() && msg.getRichData().showMessageText;
        const isNotEmpty = !msg.isEmptyResponse();
        return isRichMediaWidget && hasShowMessageText && isNotEmpty;
    }

    static createTranscriptDateElement(timeStamp, dateFormat, parentElement, style) {
        const transcriptDateElement = PrintMgr.createPrintViewElement("h2",
            "transcript-date-time", style);
        transcriptDateElement.innerText = dateFormatter(timeStamp, dateFormat);
        parentElement.appendChild(PrintMgr.createPrintViewElement("br", ""));
        parentElement.appendChild(transcriptDateElement);
    }

    static createTranscriptIDElement(printConfig, isAsync, conversationId, engagementId) {
        const transcriptIdContainer = PrintMgr.createPrintViewElement("div",
            "transcript-id", printConfig.transcriptIdStyle);
        const transcriptLabel = printConfig.transcriptIdLabel
            ? `${printConfig.transcriptIdLabel} : ` : "";
        const transcriptId = (isAsync ? conversationId : engagementId) || "";
        transcriptIdContainer.innerText = `${transcriptLabel}${transcriptId}`;
        return transcriptIdContainer;
    }

    static createTranscriptHeaderElement(printConfig) {
        const transcriptHeader = PrintMgr.createPrintViewElement("div",
            "transcript-header", printConfig.transcriptHeaderStyle);
        transcriptHeader.innerText = printConfig.transcriptHeader;
        return transcriptHeader;
    }
}
